<template>
  <div class="my-5 py-5">
    <h3 class="cm-title text-blue-v2">Últimas noticias</h3>
    <p class="last-news-subtitle">Mantente al día con las novedades y eventos importantes que están ocurriendo</p>
    <div class="py-4">
      <v-layout row wrap class="flex-container">
        <v-flex xs12 md4 v-for="(post, index) in lastPosts" :key="index" class="flex-item d-flex flex-column">
          <v-card class="card-post" elevation="0">
            <v-img :src="post.main_image" class="post-image"></v-img>
            <v-card-title class="cm-title-card">
              <h5 class="text-blue-v2 title-post"> {{ post.title }} </h5>
            </v-card-title>
            <v-card-text class="post-content">
              {{ truncateText(post.content, 150) }}
            </v-card-text>
            <v-card-actions class="card-actions">
              <v-spacer></v-spacer>
              <router-link :to="'/noticias/' + post.slug" class="cm-btn-blue">
                Leer el artículo
              </router-link>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      posts: []
    };
  },
  computed: {
    ...mapState("posts", ["lastPosts"]),
  },
  methods: {
    ...mapActions("posts", ["fetchLastPosts"]),

    truncateText(text, maxLength) {
      if (text.length <= maxLength) {
        return text;
      }
      return text.substr(0, maxLength) + '...';
    }
  },
  created() {
    const viewAs = localStorage.getItem("view_as") || null;
    this.fetchLastPosts(viewAs);
  }
};
</script>

<style scoped>
.card-post {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  box-shadow: 0rem 0.25rem 1.25rem rgba(36, 36, 38, 0.1) !important;
  transition: box-shadow 0.3s ease;
  border-radius: 0.5rem;

}
.card-post:hover {
  box-shadow: 0rem 0.5rem 1rem rgba(36, 36, 38, 0.2) !important;
}

.post-image {
  max-height: 200px;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

.flex-item {
  padding: 8px;
  display: flex;
  flex-direction: column;
}

.last-news-subtitle {
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
}

.cm-title-card {
  padding-bottom: 0rem;
}

h2 {
  font-weight: 400;
  font-size: 1.5rem;
}

.post-content {
  font-size: 1rem;
  flex-grow: 1;
}

@media (max-width: 600px) {
  .card-post {
    margin: auto;
  }
}

.cm-btn-blue {
  display: inline-block;
  padding: 0.625rem 1.25rem;
  background-color: transparent;
  border: 0.125rem solid #28385C;
  color: #28385C !important;
  border-radius: 1.25rem;
  text-transform: none;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  text-align: center;
}
.title-post {
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 1.2;
  min-height: calc(1.5rem * 1.2 * 2);
}
</style>
